<app-admin-dashboard>
  <div class="card">
    <p-breadcrumb
      class="w-full breadcrumb-style"
      [home]="breadcrumbHome"
      [model]="breadcrumbMenuItems"/>

    <div class="header-card pt-0">
      <div class="w-12 container-title">
        <h1 class="w-12 text-xl font-medium text-800 m-0">
          {{'AdminSpeciesManagement.CreateEditSpecie.NewSpecieTitle' | translate}}
        </h1>
      </div>
    </div>

    <app-form-manage-species
      [lang]="profile?.lang"
    />
  </div>
</app-admin-dashboard>

